<template>
  <article
    :class="$style.container"
  >
    <div :class="$style.heading">
      <HeadingSmall :hasMargin="false">
        {{ headerText }}
      </HeadingSmall>

      <Button
        data-test-id="ProductTourPopover__hideButton"
        hasNoBackground
        :text="$options.hideLabel"
        @click="handleHide"
      />
    </div>

    <img
      :alt="altText"
      :class="$style.diagram"
      :src="image"
    >

    <MarkdownBlock
      :class="$style.text"
      :mdTemplate="bodyText"
    />

    <footer
      :class="$style.footer"
    >
      <ProductTourPagination />
    </footer>
  </article>
</template>

<script>
import {
  Button,
  HeadingSmall,
  MarkdownBlock,
} from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';
import { productTourLabels } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';

import ProductTourPagination from './ProductTourPagination.vue';
import ProductTourSteps from './ProductTourSteps';

const onboardingModule = 'OnboardingModule';

export default {
  name: 'ProductTourPopover',

  ProductTourSteps,
  EventHelper,
  hideLabel: productTourLabels.hide,

  components: {
    Button,
    HeadingSmall,
    MarkdownBlock,
    ProductTourPagination,
  },

  props: {
    altText: {
      type: String,
      default: '',
    },
    bodyText: {
      type: String,
      default: '',
    },
    headerText: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    offset: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapState(onboardingModule, [
      'productTourStepIndex',
    ]),
  },

  methods: {
    ...mapActions(onboardingModule, [
      'setShowProductTour',
    ]),

    handleHide() {
      this.$options.EventHelper.triggerButtonClicked({
        location: productTourLabels.popoverLocation,
        step: this.productTourStepIndex,
        text: productTourLabels.hide,
      });

      this.setShowProductTour(false);
    },
  },
};
</script>

<style module scoped>
@value (max-width-large) from '~css/breakpoints.css';

.container {
  background-color: var(--jc-color-surface-light);
  border-radius: var(--jc-border-radius);
  box-shadow: var(--jc-box-shadow);
  padding: var(--jc-spacer-medium);
  position: fixed;

  /* Legacy styles forces use of px */
  width: 400px;
}

.heading {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--jc-spacer-large);
}

.diagram {
  margin-bottom: var(--jc-spacer-large);
  width: 100%;
}

.text {
  font-size: 14px;
}

.footer {
  margin-top: var(--jc-spacer-large);
}

@media (max-width: max-width-large) {
  .tooltipContent {
    width: 300px;
  }
}

</style>
